/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { User } from './User';

export enum UserTokenSource {
  ANDROID,
  IOS,
  WEB,
}

export interface UserToken {
  userId: number;
  deviceToken: string;
  source: UserTokenSource | null;
  user: User;
}
